import React from "react";
import "./WarningModal.css";

const WarningModal = ({ onConfirm, onCancel }) => {
  return (
    <div className="warning-modal-overlay">
      <div className="warning-modal-content">
        <h2>Warning: Changing Scheduling Weight</h2>
        <div className="warning-message">
          <p>
            You are about to change the scheduling weight for a doctor who may
            have existing scheduled calls. This change could impact scheduling
            fairness in the following ways:
          </p>
          <ul>
            <li>
              Historical calls were assigned based on the doctor's previous
              weight
            </li>
            <li>
              The system will now interpret past assignments using the new
              weight
            </li>
            <li>
              This may cause the doctor to appear over-scheduled or
              under-scheduled
            </li>
            <li>
              Future call assignments for other doctors may be affected to
              compensate
            </li>
          </ul>
          <p className="suggestion-text">
            <strong>Suggestion:</strong> Consider creating a new doctor profile
            and seeding appropriate artificial calls in Metrics instead.
          </p>
        </div>
        <div className="warning-modal-actions">
          <button className="warning-confirm-button" onClick={onConfirm}>
            Proceed Anyway
          </button>
          <button className="warning-cancel-button" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
